<template>
    <div class="tw-flex tw-flex-row tw-gap-4">
        <div class="tw-w-full">
            <div v-html="contents.market_place.body" class="admin-generated"></div>
        </div>
    </div>
</template>

<script>
    import AppLayoutSidebarNav from "@/Layouts/AppLayoutSidebarNav";


    export default {
        name: "MarketplaceIndex",

        layout: (h, page) => {
            return h(AppLayoutSidebarNav, [
                page
            ])
        },
        props: {
            'contents': {
                type: Object,
                required: false,
                default: function () {
                    return {}
                }
            },
        },
    }
</script>

<style scoped>

.admin-generated >>> hr {
    margin-top: 15px !important;
    margin-bottom: 15px !important;
    font-family: ABCFavorit !important;
}

</style>
